@if (oopsError()) {
  <app-info-card
    [marginTop]="true"
    type="ERROR" [subtitle]="errorMessage()!">
  </app-info-card>
} @else {
  <div class="error">
    <div class="warning-wrapper">
      <div class="warning">
        @if (extendingText()) {
          <mat-accordion class="accordion">
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title> {{ extendingText() }}</mat-panel-title>
              </mat-expansion-panel-header>
              <ng-content select="[extendingText]"></ng-content>
            </mat-expansion-panel>
          </mat-accordion>
        } @else {
          <ng-content></ng-content>
        }


      </div>

      @if (warningButtonText()) {
        <button mat-raised-button class="warning-btn" (click)="onWarningClick()">{{ warningButtonText() }}</button>
      }
    </div>
  </div>
}
